import * as FAQ from '@/services/faq';

export default {
  namespaced: true,

  state: {
    all: {}
  },

  mutations: {
    SET_FAQS(state, payload) {
      state.all = payload;
    }
  },

  actions: {
    GET_FAQS({ commit, state }, payload) {
      return FAQ.getFAQs()
        .then(response => {
          commit('SET_FAQS', response.data);

          return response;
        })
        .catch(err => {
          return err;
        });
    }
  }
};
